// extracted by mini-css-extract-plugin
export default {"payableInbox":"PayableInbox_payableInbox__WVb0q","footerText":"PayableInbox_footerText__zkw6d"};